<template>
  <header id="header">
    <HeaderBackground />
    <div class="container">
      <Navigation
        v-on:showLoginModal="$emit('showLoginModal')"
        v-on:showRegistrationModal="$emit('showRegistrationModal')"
        v-bind:setWasClickedToScroll="setWasClickedToScroll"
      />
      <div class="spacer" />
      <div class="content">
        <h1 class="heading">
          Konferencija<br />za novu generaciju&nbsp;<br class="tablet-break" />
          <span class="typewriter-blue">
            <span class="tortellini"></span>
          </span>
        </h1>
        <div class="date-time">14. i 15. svibnja 2021. - FESB, Split</div>
        <div class="header__buttons">
          <div>
            <template v-if="!isLoggedIn">
              <div class="buttons-wrapper">
                <button class="cta--primary" v-on:click="$emit('showLoginModal')">Prijava</button>
                <a class="button-discord" :href="discordLink" target="_blank" rel="noopener noreferrer">
                  <img src="@/assets/app-icons/home/discord.svg" />Pridruži se
                </a>
              </div>
            </template>
            <template v-else>
              <div class="buttons-wrapper">
                <button class="cta--primary" v-on:click="routeToApp()">APLIKACIJA</button>
                <a class="button-discord" :href="discordLink" target="_blank" rel="noopener noreferrer">
                  <img src="@/assets/app-icons/home/discord.svg" />Pridruži se
                </a>
              </div>
            </template>
          </div>
        </div>
        <div class="header-active-wrapper">
          <HeaderActiveEvent v-bind:event="activeEvent" />
        </div>
      </div>
      <span class="trigger trigger--top" ref="triggerTop" />
      <span class="trigger trigger--bottom" ref="triggerBottom" />
    </div>
  </header>
</template>

<script>
import Typed from 'typed.js';
import VueScrollTo from 'vue-scrollto';

import { discordLink } from '@/config';

import Navigation from '@/components/landing-page/Navigation.vue';
import HeaderBackground from '@/components/landing-page/HeaderBackground.vue';
import HeaderActiveEvent from '@/components/landing-page/HeaderActiveEvent.vue';
import arrowDown from '@/assets/icons/arrow-down.svg';

export default {
  name: 'Header',
  components: {
    Navigation,
    HeaderBackground,
    HeaderActiveEvent,
  },
  props: {
    activeEvent: {},
  },
  data() {
    return {
      arrowDown: arrowDown,
      wasClickedToScroll: true,
      handleIntersect: {},
      discordLink,
    };
  },
  computed: {
    isLoggedIn: function() {
      let token = localStorage.getItem('token');
      if (!token) return false;

      let decoded = this.$decode(token);

      if (!decoded) return false;

      return true;
    },
  },
  methods: {
    isAdmin: function() {
      let token = localStorage.getItem('token');
      if (!token) return false;

      let decoded = this.$decode(token);

      if (!decoded) return false;

      if (decoded.roles === 'Administrator') return true;

      return false;
    },
    routeToApp: function() {
      this.isAdmin() ? this.$router.push('admin') : this.$router.push('app');
    },
    setWasClickedToScroll: function(value) {
      this.wasClickedToScroll = value;
    },
    scrollDownOnClick: function() {
      this.setWasClickedToScroll(true);
      VueScrollTo.scrollTo('#conference', 700, {
        offset: -100,
        cancelable: false,
      });
    },
  },
  mounted() {
    const typewriterOptions = {
      strings: ['developera', 'dizajnera', 'marketingaša', 'poduzetnika', 'digitalaca'],
      typeSpeed: 100,
      loop: true,
      backSpeed: 80,
      backDelay: 1500,
    };

    new Typed('.tortellini', typewriterOptions);
  },
  beforeDestroy() {
    this.handleIntersect = () => {};
  },
};
</script>

<style scoped>
#header {
  overflow: hidden;
}

.trigger {
  position: absolute;
  width: 1px;
  height: 1px;
  background-color: transparent;
}

.trigger--top {
  top: 10px;
  left: 0;
}

.trigger--bottom {
  bottom: 10px;
  left: 0;
}

.mobile-break,
.tablet-break {
  display: none;
}

.buttons-wrapper {
  display: flex;
  align-items: center;
}

.button-discord {
  border: 1px solid rgba(255, 255, 255, 0.8);
  background: transparent;
  border-radius: 15px;
  padding: 12px 32px;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: white;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  text-decoration: none;
}

.button-discord img {
  margin-right: 8px;
}

@media screen and (max-width: 350px) {
  .button-discord {
    padding: 12px;
  }

  header > .container {
    padding-top: 310px !important;
  }
}

header {
  position: relative;
}

.typewriter-blue {
  position: relative;
  color: #30cec2;
  line-height: initial;
}

.header__more {
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  margin-bottom: 30px;
  -webkit-tap-highlight-color: transparent;
}

.header__more h4 {
  color: #7a8e94;
  font-size: 18px;
  margin-bottom: 16px;
  font-weight: 500;
}

.header__more img {
  animation: floatUnder 1.5s ease-in-out infinite;
}

@keyframes floatUnder {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(5px) rotate(0.02deg);
  }
}

header > .container {
  width: 100%;
  max-width: 1440px;
  margin: auto;
  height: 100vh;
  padding: 210px 100px 0 100px;
  position: relative;
  z-index: 1;
  overflow-y: hidden;
}

.content {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.content .header-active-wrapper {
  display: inline-flex;
  flex-direction: column;
  justify-content: flex-end;
  margin-bottom: 18px;
  flex-grow: 1;
}

.heading {
  color: #fff;
  font-family: 'Fuse V.2 Display', 'Arial', sans-serif;
  font-size: 64px;
  font-weight: 800;
  line-height: 77px;
  align-self: center;
  width: 100%;
}

.date-time {
  margin-top: 16px;
  color: #ffffffcc;
  font-family: 'Fuse V.2 Display', 'Arial', sans-serif;
  font-size: 20px;
  line-height: 30px;
}

.header__buttons {
  display: flex;
  margin-top: 16px;
  font-weight: 800;
}

.header__cta--alt {
  color: #5ec4bc;
  background: none;
  outline: 0;
  box-shadow: none;
  margin-left: 28px;
}

.header__cta:hover {
  opacity: 0.8;
}

@media screen and (max-width: 1340px) {
  .heading {
    font-size: 44px;
  }

  .date-time {
    font-size: 16px;
  }

  .date-time li {
    font-size: 18px;
  }
}

@media screen and (max-width: 1200px) {
  .heading {
    font-size: 42px;
  }
}

@media screen and (max-width: 1100px) {
  .heading {
    font-size: 40px;
  }

  .date-time li {
    font-size: 16px;
  }
}

@media screen and (max-width: 1050px) {
  .heading {
    font-size: 38px;
  }
}

@media screen and (max-width: 1000px) {
  .heading {
    font-size: 44px;
    line-height: 52px;
    margin-right: 0;
    display: block;
  }

  .date-time li {
    font-size: 18px;
  }
}

@media screen and (max-width: 797px) {
  header > .container {
    padding: 400px 24px 0 24px;
  }

  .date-time {
    margin-top: 20px;
  }

  .heading {
    font-size: 42px;
  }
}

@media screen and (max-width: 700px) {
  .mobile-break,
  .tablet-break {
    display: block;
  }
}

@media screen and (max-width: 450px) {
  .content {
    margin-bottom: -20%;
  }

  .heading {
    font-size: 36px;
    line-height: 45px;
  }

  .date-time li {
    font-size: 14px;
    line-height: 17px;
  }
}

@media screen and (max-width: 385px) {
  .heading {
    font-size: 34px;
    line-height: 42px;
  }

  .date-time li {
    font-size: 14px;
    line-height: 15px;
  }
}

@media screen and (max-width: 365px) {
  .heading {
    font-size: 30px;
    line-height: 38px;
  }
}
</style>
